<template>
  <div class="container-income-report">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow>
        <template #left>
          <div style="display: flex; align-items: center" @click="handleBackPath">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
            {{ $t('lang.mybean.incomeReport') }}
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="report-swipe">
      <swiper class="my-swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="item in serviceAdvantageData" :key="item.id">
          <div class="card-box" :style="{ background: `url(${item.image})`, 'background-size': '100% 100%' }">
            <span class="card-title">{{ $t('lang.mybean.weeklyIncome') }}</span>
            <div class="card-beans">
              <i>{{ data.amount }}</i>
              <img :src="getMatchImg('beans')" alt="" />
            </div>
            <span class="card-time">{{ data.weekStart }}-{{ data.weekEnd }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="report-list">
      <div class="list-item" @click="toPage(item.day)" v-for="item in listDay" :key="item">
        <div class="time">{{ item.day }}</div>
        <div class="beans">
          <span>{{ item.amount }}</span>
          <img :src="getMatchImg('beans')" alt="" />
          <img class="arraw" src="@/assets/packageAssets/common/arrow05.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 大写 Swiper, SwiperSlide
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { apiFetchReport } from '@/api/imee'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data() {
    let self = this
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
          //区分不同Swiper的组件
        },
        followFinger: false, // 滑动时slide不动，释放鼠标或手指时slide切换
        loop: false, //开启循环
        loopedSlides: 4, //设置平滑
        pagination: '.swiper-pagination',
        slidesPerView: 'auto', // 设置能够同时显示的数量（可设置 auto）
        // slidesPerView: 2, // 设置能够同时显示的数量（可设置 auto）
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 0, // 间距
        speed: 500, //切换速度
        autoplay: false, //是否开启自动轮播
        initialSlide: 4, //默认页
        // 事件
        on: {
          slideChangeTransitionStart: function () {
            self.handleClickCard(this.activeIndex)
          }
        }
      },

      serviceAdvantageData: [
        {
          id: 0,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/vava/report_bg1.png')
        },
        {
          id: 1,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/vava/report_bg2.png')
        },
        {
          id: 2,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/vava/report_bg3.png')
        },
        {
          id: 3,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/vava/report_bg4.png')
        }
      ],
      // 当前时间
      nowTime: new Date().getTime(),
      data: {},
      listDay: []
    }
  },
  created() {
    this.fetchReport()
  },
  mounted() {},
  methods: {
    handleBackPath() {
      this.goPrevious()
    },

    toPage(day) {
      this.$router.push({
        path: '/income/report/details',
        query: {
          date: day
        }
      })
    },

    fetchReport() {
      apiFetchReport(this.nowTime).then((res) => {
        if (res) {
          this.data = res
          this.listDay = res.listDay
          this.nowTime = null
        }
      })
    },

    handleClickCard(index) {
      let weekTime = Number(7 * 24 * 60 * 60 * 1000)
      let now = Number(new Date().getTime())
      if (index == 0) {
        this.nowTime = now - weekTime * 3
      } else if (index == 1) {
        this.nowTime = now - weekTime * 2
      } else if (index == 2) {
        this.nowTime = now - weekTime * 1
      } else {
        this.nowTime = new Date().getTime()
      }
      this.fetchReport()
    }
  },
  watch: {},
  computed: {}
}
</script>
<style lang="scss" scoped>
.container-income-report {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .report-swipe {
    .my-swiper {
      width: 100%;
    }
    .swiper-slide {
      width: 90%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      border-radius: 12px;
    }

    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
    }
    .swiper-slide-prev {
      position: relative;
      right: -90px !important;
    }
    .swiper-slide-next {
      position: relative;
      left: -90px !important;
    }
    .card-box {
      width: 234px;
      height: 142px;
      padding: 12px;
      position: relative;
      border-radius: 10px;
      color: #ffffff;

      .card-title {
        font-family: Inter-Medium;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
      }
      .card-beans {
        width: 100%;
        margin: 24px auto 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Inter-SemiBold;
        font-weight: 600;
        font-size: 30px;
        line-height: 36px;
        > img {
          width: 30px;
          margin-left: 4px;
        }
      }
      .card-time {
        display: block;
        width: 100%;
        text-align: center;
        font-family: Inter-Regular;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
      }
    }
  }

  .report-list {
    width: 100%;
    height: 52px;
    padding: 0 23px;
    margin-top: 40px;

    .list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      font-family: Inter-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      border-bottom: 1px solid #f9f9fb;
      .time {
        color: #666;
      }
      .beans {
        display: flex;
        align-items: center;
        > img {
          width: 20px;
          margin-left: 4px;
        }
        .arraw {
          transform: rotate(180deg);
          width: 15px;
        }
      }
    }
    .list-item:first-child {
      border-top: 1px solid #f9f9fb;
    }
  }
}

::v-deep .van-nav-bar__title {
  color: #000;
  font-family: F-Medium;
}
::v-deep .van-nav-bar__left {
  font-family: Inter;
  font-weight: bold;
  font-size: 17px;
  color: #000;
  line-height: 20px;
}
::v-deep .van-swipe-item {
  border: 1px solid pink;
  .image {
    height: 142px;
  }
}
</style>
